"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Notification = _interopRequireDefault(require("../../Atoms/Notification"));
require("./SKUTilesNotification.scss");
var SKUTilesNotification = function SKUTilesNotification(_ref) {
  var productItem = _ref.productItem,
    product = _ref.product,
    labels = _ref.labels,
    config = _ref.config;
  var _productItem$isFreeGi = productItem.isFreeGift,
    isFreeGift = _productItem$isFreeGi === void 0 ? false : _productItem$isFreeGi,
    _productItem$isFreePr = productItem.isFreeProduct,
    isFreeProduct = _productItem$isFreePr === void 0 ? false : _productItem$isFreePr;
  var isFreeItem = product.isFreeItem,
    isHazardous = product.isHazardous,
    isColdChain = product.isColdChain;
  var freeItemTitle = labels.freeItemTitle,
    freeItemDescription = labels.freeItemDescription,
    hazardousMaterialTitle = labels.hazardousMaterialTitle,
    hazardousMaterialDescription = labels.hazardousMaterialDescription,
    coldShippingTitle = labels.coldShippingTitle,
    coldShippingDescription = labels.coldShippingDescription,
    freeItemText = labels.freeItemText;
  var freeItemIconUrl = config.freeItemIconUrl,
    hazardousIconUrl = config.hazardousIconUrl,
    coldShippingIconUrl = config.coldShippingIconUrl;
  var isNotificationActive = isFreeItem || isHazardous || isColdChain;
  var isFreeProductItem = isFreeGift || isFreeProduct;
  return _react.default.createElement(_react.default.Fragment, null, isFreeProductItem && _react.default.createElement("div", {
    className: "free-item-text",
    "data-locator": "free-item-text"
  }, freeItemText), isNotificationActive && _react.default.createElement("div", {
    className: "row skutile-notification-container",
    "data-locator": "sku-tile-notification-container"
  }, isFreeItem && _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement(_Notification.default, {
    title: freeItemTitle,
    description: freeItemDescription,
    type: "small",
    icon: freeItemIconUrl,
    elementLocator: "notification-container-" + freeItemTitle
  })), isHazardous && _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement(_Notification.default, {
    title: hazardousMaterialTitle,
    description: hazardousMaterialDescription,
    type: "small",
    icon: hazardousIconUrl,
    elementLocator: "notification-container-" + hazardousMaterialTitle
  })), isColdChain && _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement(_Notification.default, {
    title: coldShippingTitle,
    description: coldShippingDescription,
    type: "small",
    icon: coldShippingIconUrl,
    elementLocator: "notification-container-" + coldShippingTitle
  }))));
};
SKUTilesNotification.defaultProps = {
  productItem: {},
  product: {},
  labels: {},
  config: {}
};
var _default = SKUTilesNotification;
exports.default = _default;
module.exports = exports["default"];